import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
    from { transform: translateY(100%); }
    to { transform: translateY(0); }
`;

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    /* MUI Dialog(z-index ~1300) 위에 떠야 하므로 충분히 높게 */
    z-index: 13000;
    display: flex;
    align-items: flex-end;
    justify-content: center;
`;

export const Sheet = styled.div`
    width: 100%;
    max-width: 520px;
    background: #fff;
    border-radius: 16px 16px 0 0;
    box-shadow: 0 -6px 24px rgba(0, 0, 0, 0.18);
    padding: 8px 16px 16px;
    padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
    display: flex;
    flex-direction: column;
    gap: 14px;
    box-sizing: border-box;
    animation: ${slideUp} 0.22s ease-out;
`;

export const Handle = styled.div`
    width: 40px;
    height: 4px;
    border-radius: 2px;
    background: #cbd5e0;
    margin: 4px auto 2px;
`;

export const Label = styled.div`
    text-align: center;
    font-size: 15px;
    font-weight: 700;
    color: #1a202c;
`;

export const ValueRow = styled.div`
    display: flex;
    align-items: stretch;
    gap: 10px;

    .stepButton {
        flex-shrink: 0;
        width: 64px;
        height: 64px;
        border: 1px solid #cbd5e0;
        border-radius: 12px;
        background: #f7fafc;
        font-size: 28px;
        font-weight: 700;
        color: #2d3748;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:active {
            background: #e2e8f0;
        }

        &.minus {
            color: var(--redColor1, #ef4444);
        }
        &.plus {
            color: var(--blueColor1, #2563eb);
        }
    }

    .valueInput {
        flex: 1;
        min-width: 0;
        height: 64px;
        text-align: center;
        /* 16px 이상이라 iOS 포커스 시 줌 안됨 */
        font-size: 30px;
        font-weight: 800;
        color: #1a202c;
        border: 1px solid #cbd5e0;
        border-radius: 12px;
        background: #fff;
        outline: none;
        box-sizing: border-box;

        &:focus {
            border-color: var(--blueColor1, #2563eb);
            box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2);
        }
    }
`;

export const QuickRow = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;

    .quickButton {
        height: 52px;
        border-radius: 10px;
        border: 1px solid transparent;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;

        &:active {
            transform: translateY(1px);
        }

        &.up {
            background: #eff4ff;
            border-color: #bcd0ff;
            color: var(--blueColor1, #2563eb);
        }
        &.down {
            background: #fff0f0;
            border-color: #ffc9c9;
            color: var(--redColor1, #ef4444);
        }
    }
`;

export const Footer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-top: 2px;

    button {
        height: 56px;
        border-radius: 12px;
        border: none;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;

        &.cancel {
            background: #edf2f7;
            color: #4a5568;
        }
        &.confirm {
            background: var(--blueColor1, #2563eb);
            color: #fff;
        }

        &:active {
            transform: translateY(1px);
        }
    }
`;
